<template>
  <div class="flex">
    <div
      class="flex flex-col mx-auto p-4 w-full h-full items-center text-blue-800 my-4"
      style="text-align: center"
    >
      <div class="flex flex-col w-full px-12 gap-2">
        <div class="grid grid-cols-1 gap-2">
          <p class="col-span-1 text-left text-xl font-bold">
            {{ $t("production_order_list.get_production_orders") }}
          </p>
          <div class="content-start p-4 bg-gray-200">
            <div class="w-full flex flex-row justify-between items-center">
              <div class="flex flex-col items-start flex-1 w-full">
                <div class="flex flex-row w-full gap-4">
                  <div class="flex flex-col items-start flex-1 w-1/3">
                    <label
                      for="email_address"
                      class="block font-medium text-sm text-gray-700"
                      >{{
                        $t("production_order_list.input.email.label")
                      }}</label
                    >
                    <div class="flex flex-row justify-center w-full">
                      <input
                        @keyup.enter="searchUsersInQueue()"
                        id="email_address"
                        type="text"
                        v-model="filter.email"
                        :placeholder="
                          $t('production_order_list.input.email.placeholder')
                        "
                        class="
                          w-full
                          mt-1
                          p-2
                          h-10
                          border-2 border-solid border-black
                          rounded-md
                          "
                      />
                    </div>
                  </div>
                  <div
                    v-if="showRetailers && retailers.length > 0"
                    class="flex flex-col items-start flex-1 w-1/3"
                  >
                    <label
                      for="retailer"
                      class="block font-medium text-sm text-gray-700"
                      >{{
                        $t("production_order_list.input.retailer.label")
                      }}</label
                    >
                    <div class="flex flex-row justify-center w-full">
                      <v-select
                        id="retailer"
                        v-model="selectedRetailer"
                        :options="retailers"
                        label="company_name"
                        :placeholder="
                          $t(
                            'production_order_list.input.retailer.no_selection'
                          )
                        "
                        :searchable="false"
                        @input="onRetailerSelect"
                        class="w-full mt-1 tailie-select"
                      />
                    </div>
                  </div>
                  <div class="flex flex-col items-start flex-1 w-1/3">
                    <label
                      for="retailer_code"
                      class="block font-medium text-sm text-gray-700"
                      >{{
                        $t("production_order_list.input.retailer_code.label")
                      }}</label
                    >
                    <div class="flex flex-row justify-center w-full">
                      <v-select
                        id="retailer_code"
                        v-model="selectedRetailerCode"
                        :options="retailerCodes"
                        label="code"
                        :placeholder="
                          $t(
                            'production_order_list.input.retailer_code.no_selection'
                          )
                        "
                        :filterable="true"
                        @input="onRetailerCodeSelect"
                        class="w-full mt-1 tailie-select"
                      >
                        <template #no-options>
                          {{
                            $t(
                              "production_order_list.input.retailer_code.no_options"
                            )
                          }}
                        </template>
                      </v-select>
                    </div>
                  </div>
                </div>
                <div class="flex flex-row w-full gap-4 mt-4 ">
                  <div class="flex flex-col items-start flex-1 w-1/3">
                    <label
                      for="order_number"
                      class="block font-medium text-sm text-gray-700"
                      >{{
                        $t("production_order_list.input.order_number.label")
                      }}</label
                    >
                    <div class="flex flex-row justify-center w-full">
                      <input
                        @keyup.enter="searchUsersInQueue()"
                        id="order_number"
                        type="text"
                        v-model="filter.orderNumber"
                        :placeholder="
                          $t(
                            'production_order_list.input.order_number.placeholder'
                          )
                        "
                        class="
                          w-full
                          mt-1
                          p-2
                          h-10
                          border-2 border-solid border-black
                          rounded-md
                          "
                      />
                    </div>
                  </div>
                  <div class="flex flex-col items-start flex-1">
                    <label
                      for="order_status"
                      class="block font-medium text-sm text-gray-700"
                      >{{
                        $t("production_order_list.input.order_status.label")
                      }}</label
                    >
                    <div class="flex flex-row justify-center w-full">
                      <v-select
                        id="order_status"
                        v-model="selectedOrderStatus"
                        :options="orderStatusFilterOptions"
                        label="label"
                        :placeholder="
                          $t(
                            'production_order_list.input.order_status.no_selection'
                          )
                        "
                        :searchable="false"
                        @input="onOrderStatusSelect"
                        class="w-full mt-1 tailie-select"
                      />
                    </div>
                  </div>
                  <div v-if="showRetailers" class="flex-1"></div>
                </div>
              </div>
              <div class="flex flex-col items-center mx-4">
                <button
                  @click="searchUsersInQueue()"
                  :class="{
                    'h-10 text-md px-2 mx-2 text-white': true,
                    'bg-blue-800':
                      emailFilled ||
                      codeFilled ||
                      orderNumberFilled ||
                      retailerFilled ||
                      orderStatusFilled,
                    'bg-gray-600':
                      !emailFilled &&
                      !codeFilled &&
                      !orderNumberFilled &&
                      !retailerFilled &&
                      !orderStatusFilled
                  }"
                  :disabled="
                    !emailFilled &&
                      !codeFilled &&
                      !orderNumberFilled &&
                      !retailerFilled &&
                      !orderStatusFilled
                  "
                >
                  {{ $t("production_order_list.buttons.search_for_orders") }}
                </button>
                <button class="h-10 text-md px-3 mx-2" @click="clearSearch()">
                  {{ $t("production_order_list.buttons.clear") }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-3 gap-4">
          <div class="col-span-1 w-full border-solid border-2 self-start">
            <div v-if="usersLoading" class="p-4 text-left">
              {{ $t("production_order_list.users_table.loading") }}
            </div>
            <div v-else>
              <div class="flex items-center justify-between py-4 px-4">
                <p class="text-left font-bold">
                  {{ $t("production_order_list.users_table.header") }}
                </p>
                <div class="flex items-center gap-2">
                  <button
                    class="text-sm px-2 py-1 border rounded bg-blue-800 text-white"
                    @click="userSortOrderAscending = !userSortOrderAscending"
                  >
                    {{ userSortOrderAscending ? "A-Z ↑" : "Z-A ↓" }}
                  </button>
                </div>
              </div>
              <div v-if="users.length === 0" class="mb-4">
                {{ $t("production_order_list.users_table.no_users_found") }}
              </div>
              <div class="flex flex-col max-h-full overflow-hidden px-4" v-else>
                <div
                  class="w-full border-solid mt-3 data-table-left-section overflow-y-auto table-parent"
                >
                  <div
                    v-for="(user, index) in this.sortedUsers"
                    :key="index"
                    @click="selectedUser = user"
                    v-bind:class="[
                      'cursor-pointer hover:bg-gray-50 py-3 px-2 text-left text-sm',
                      selectedUser && selectedUser.id === user.id
                        ? 'font-bold'
                        : 'font-normal',
                      sortedUsers !== undefined &&
                      index === sortedUsers.length - 1
                        ? ''
                        : 'border-b'
                    ]"
                  >
                    {{ user.email }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-span-2">
            <div v-if="!selectedUser">
              <div class="border-solid border-2 p-4 text-left">
                {{ $t("production_order_list.selected_user.no_user_selected") }}
              </div>
            </div>
            <div v-else class="flex flex-col w-full gap-4">
              <div class="border-solid border-2 p-4 text-left">
                <b>{{
                  $t("production_order_list.selected_user.user_selected")
                }}</b>
                {{ selectedUser.email }}
              </div>
              <div class="border-solid border-2 p-4 text-left">
                <production-order-bodyprint-queue-table
                  :queue-items="queueItems"
                  :queue-loading="queueLoading"
                  :selected-queue-item="selectedQueueItem"
                  @queue-item-selected="item => (selectedQueueItem = item)"
                />
              </div>
              <div class="border-solid border-2 p-4 text-left">
                <div v-if="!selectedQueueItem">
                  {{
                    $t(
                      "production_order_list.orders_table.no_bodyprint_selected"
                    )
                  }}
                </div>
                <div v-else>
                  <production-order-orders-table
                    :items-for-queue="itemsForQueue"
                    :orders-loading="ordersLoading"
                    @handle-view="item => requestOrderToView(item)"
                    @handle-edit="item => requestOrderToEdit(item)"
                    @handle-measurements="
                      item => requestMeasurementsForOrder(item)
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <measurements-modal
      :loading="measurementsLoading"
      :showModal="showMeasurementsModal"
      :bodyprintId="measurementsBodyprintId"
      :data="measurementsBodyprint"
      :onClose="
        () => {
          showMeasurementsModal = false;
          measurementsBodyprintId = null;
          measurementsBodyprint = null;
        }
      "
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProductionOrderBodyprintQueueTable from "@/components/production-order/production-order-bodyprint-queue-table.vue";
import ProductionOrderOrdersTable from "@/components/production-order/production-order-orders-table.vue";
import MeasurementsModal from "@/components/modals/measurements-modal.vue";
import {
  ROUTE_PRODUCTION_ORDER_EDIT,
  ROUTE_PRODUCTION_ORDER_CHECK
} from "@/router";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { RetailerOrderStatus } from "@/enums";

export default {
  name: "ProductionListViewNew",
  components: {
    vSelect,
    MeasurementsModal,
    ProductionOrderBodyprintQueueTable,
    ProductionOrderOrdersTable
  },
  computed: {
    ...mapGetters({
      getAuthLoggedIn: "auth/getAuthLoggedIn",
      getAuth: "auth/getAuth",
      getUserData: "user/getUserData",
      getSidebarOpen: "layout/getSidebarOpen"
    }),
    ...mapActions(["auth/authCheck", "layout/toggleSidebar"]),
    sortedUsers() {
      const list = Array.isArray(this.users) ? [...this.users] : [];
      return list.sort((a, b) => {
        const ae = (a && a.email ? a.email : "").toString();
        const be = (b && b.email ? b.email : "").toString();
        const cmp = ae.localeCompare(be, undefined, { sensitivity: "base" });
        return !this.userSortOrderAscending ? -cmp : cmp;
      });
    }
  },
  data() {
    return {
      orderRegex: /^\d{4}\.\d{2}\.\d{6}$/,
      orderStatusFilterOptions: [
        {
          label: this.$t("general.status.retailer_order.new"),
          value: RetailerOrderStatus.NEW
        },
        {
          label: this.$t("general.status.retailer_order.in_review"),
          value: RetailerOrderStatus.IN_REVIEW
        },
        {
          label: this.$t("general.status.retailer_order.in_progress"),
          value: RetailerOrderStatus.IN_PROGRESS
        },
        {
          label: this.$t("general.status.retailer_order.in_production"),
          value: RetailerOrderStatus.IN_PRODUCTION
        },
        {
          label: this.$t("general.status.retailer_order.sent_to_customer"),
          value: RetailerOrderStatus.SENT_TO_CUSTOMER
        }
      ],
      dataProvided: false,
      loading: false,
      usersLoading: false,
      queueLoading: false,
      ordersLoading: false,
      tableLoading: false,
      loaded: false,
      failed: false,
      filter: {
        email: "",
        code: "",
        retailer: "",
        orderNumber: "",
        orderStatus: ""
      },
      selectedRetailerCode: null,
      selectedRetailer: null,
      selectedOrderStatus: null,
      emailFilled: false,
      codeFilled: false,
      orderNumberFilled: false,
      orderStatusFilled: false,
      retailerFilled: false,
      errorMessage: null,
      measurementsLoading: false,
      showMeasurementsModal: false,
      measurementsBodyprint: null,
      measurementsBodyprintId: null,
      orders: [],
      users: [],
      queueItems: [],
      itemsForQueue: [],
      selectedUser: null,
      selectedQueueItem: null,
      retailers: [],
      showRetailers: false,
      retailerCodes: [],
      userSortOrderAscending: true,
      isFirstChange: true
    };
  },
  methods: {
    getRetailerList() {
      this.$store.dispatch("retailer/getRetailerList").then(() => {
        this.showRetailers = true;
        this.retailers = this.$store.getters["retailer/getRetailers"];
      });
    },
    getRetailerCodes() {
      this.$store.dispatch("retailer/getRetailerCodesForOrders").then(() => {
        this.retailerCodes = this.$store.getters["retailer/getRetailerCodes"];
      });
    },
    getFilterPayload(
      email = null,
      code = null,
      retailer = null,
      order = null,
      status = null
    ) {
      return {
        email: email || this.filter.email,
        code: code || this.filter.code,
        retailer: retailer || this.filter.retailer,
        order: order || this.filter.orderNumber,
        status: status || this.filter.orderStatus
      };
    },
    onRetailerCodeSelect(selected) {
      this.filter.code = selected ? selected.code : "";
      this.searchUsersInQueue();
    },
    onRetailerSelect(selected) {
      this.filter.retailer = selected ? selected._id : "";
      this.searchUsersInQueue();
    },
    onOrderStatusSelect(selected) {
      this.filter.orderStatus = selected ? selected.value : "";
      this.searchUsersInQueue();
    },
    searchUsersInQueue() {
      // Clear existing selected data
      this.selectedUser = null;
      this.selectedQueueItem = null;

      this.users = [];
      this.usersLoading = true;

      this.$store
        .dispatch("retailerOrders/getAllUsersInQueue", this.getFilterPayload())
        .then(() => {
          this.users = this.$store.getters["retailerOrders/getUsersInQueue"];
          this.usersLoading = false;

          if (
            this.filter.orderNumber !== "" &&
            this.orderRegex.test(this.filter.orderNumber) &&
            this.users.length > 0
          ) {
            [this.selectedUser] = this.users;
          }
        });

      this.selectedUser =
        JSON.parse(localStorage.getItem("selectedUser")) ?? null;
    },
    clearSearch() {
      this.filter.email = "";
      this.filter.code = "";
      this.filter.retailer = "";
      this.filter.orderNumber = "";
      this.filter.orderStatus = "";

      this.selectedRetailerCode = null;
      this.selectedRetailer = null;
      this.selectedOrderStatus = null;

      this.selectedUser = null;
      this.selectedQueueItem = null;

      localStorage.removeItem("selectedQueueItem");
      localStorage.removeItem("selectedUser");
      localStorage.removeItem("filter");

      this.getRetailerCodes();
      this.getRetailerList();
      this.searchUsersInQueue();
    },
    requestOrderToView(order) {
      const goToViewPage = orderId => {
        if (this.getSidebarOpen) {
          this.$store.dispatch("layout/toggleSidebar");
        }
        this.saveToLocalStorage();
        this.$router.push({
          name: ROUTE_PRODUCTION_ORDER_CHECK,
          params: { order_id: orderId }
        });
      };

      goToViewPage(order.id);
    },
    requestOrderToEdit(order) {
      const goToEditPage = orderId => {
        if (this.getSidebarOpen) {
          this.$store.dispatch("layout/toggleSidebar");
        }
        this.saveToLocalStorage();
        this.$router.push({
          name: ROUTE_PRODUCTION_ORDER_EDIT,
          params: { order_id: orderId }
        });
      };

      goToEditPage(order.id);
    },
    requestMeasurementsForOrder(order) {
      this.sizesLoading = true;
      this.$store
        .dispatch("retailerOrders/requestMeasurements", { id: order.id })
        .then(() => {
          console.log(order);
          this.measurementsLoading = false;
          this.showMeasurementsModal = true;
          this.measurementsBodyprintId = order.queue_item.bodyprint._id;
          this.measurementsBodyprint = this.$store.getters[
            "retailerOrders/getMeasurementsForQueueItem"
          ];
        })
        .catch(() => {
          this.measurementsBodyprint = null;
          this.measurementsBodyprintId = null;
          this.measurementsLoading = false;
          this.errorMessage = this.$t(
            "bodyprint_queue.errors.could_not_find_bodyprint_user"
          );
        });
    },
    saveToLocalStorage() {
      localStorage.setItem("selectedUser", JSON.stringify(this.selectedUser));
      localStorage.setItem(
        "selectedQueueItem",
        JSON.stringify(this.selectedQueueItem)
      );
      localStorage.setItem("filter", JSON.stringify(this.filter));
    }
  },
  created() {
    if (!this.getSidebarOpen) {
      this.$store.dispatch("layout/toggleSidebar");
    }

    this.getRetailerCodes();
  },
  mounted() {
    this.filter = JSON.parse(localStorage.getItem("filter")) ?? this.filter;
    this.selectedOrderStatus = this.orderStatusFilterOptions.filter(item => {
      return item.value === this.filter.orderStatus;
    });

    this.searchUsersInQueue();
  },
  watch: {
    getUserData() {
      if (this.getUserData) {
        if (
          this.getUserData.roles.includes("admin") ||
          this.getUserData.roles.includes("employee")
        ) {
          this.getRetailerList();
        }
      }
    },
    filter: {
      handler(newFilter) {
        this.emailFilled = newFilter.email !== "";
        this.codeFilled = newFilter.code !== "";
        this.retailerFilled = newFilter.retailer !== "";
        this.orderNumberFilled = newFilter.orderNumber !== "";
        this.orderStatusFilled = newFilter.orderStatus !== "";
      },
      deep: true
    },
    selectedUser() {
      if (this.selectedUser) {
        this.queueLoading = true;

        this.$store
          .dispatch(
            "retailerOrders/getOrderQueueForUser",
            this.getFilterPayload(this.selectedUser.email)
          )
          .then(() => {
            this.queueLoading = false;
            this.queueItems = this.$store.getters[
              "retailerOrders/getItemsForUser"
            ];

            if (
              this.filter.orderNumber !== "" &&
              this.orderRegex.test(this.filter.orderNumber) &&
              this.users.length > 0
            ) {
              [this.selectedQueueItem] = this.queueItems || [];
            } else {
              if (this.isFirstChange) {
                this.isFirstChange = false;
                this.selectedQueueItem =
                  JSON.parse(localStorage.getItem("selectedQueueItem")) ?? null;
              } else {
                this.selectedQueueItem = null;
                localStorage.removeItem("selectedQueueItem");
                localStorage.removeItem("selectedUser");
              }
            }
          });
      }
    },
    selectedQueueItem() {
      this.ordersLoading = true;
      if (!this.selectedQueueItem) return;

      if (this.filter.orderNumber !== "" || this.filter.orderStatus !== "") {
        this.$store
          .dispatch("retailerOrders/getFilteredForQueueItem", {
            queueId: this.selectedQueueItem.id,
            orderNumber: this.filter.orderNumber,
            orderStatus: this.filter.orderStatus
          })
          .then(() => {
            this.itemsForQueue = this.$store.getters[
              "retailerOrders/getItemsForQueueItem"
            ];
            this.ordersLoading = false;
          });
      } else {
        this.$store
          .dispatch("retailerOrders/getForQueueItem", this.selectedQueueItem.id)
          .then(() => {
            this.itemsForQueue = this.$store.getters[
              "retailerOrders/getItemsForQueueItem"
            ];
            this.ordersLoading = false;
          });
      }
    },
    retailers() {
      this.selectedRetailer = this.retailers.filter(item => {
        return item._id === this.filter.retailer;
      });
    },
    retailerCodes() {
      this.selectedRetailerCode = this.retailerCodes.filter(item => {
        return item.code === this.filter.code;
      });
    }
  }
};
</script>
